import { memo } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { DashboardInsights } from "@/components/dashboard/DashboardInsights";

interface SuccessionInsightsProps {
  onClose: () => void;
}

const SuccessionInsights = memo(function SuccessionInsights({ onClose }: SuccessionInsightsProps) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-background rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b">
          <div>
            <h1 className="text-2xl font-semibold">Succession Insights</h1>
            <p className="text-muted-foreground">Detailed AI-powered recommendations for your succession plan</p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-8 w-8"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
          <DashboardInsights />
        </div>
      </div>
    </div>
  );
});

SuccessionInsights.displayName = "SuccessionInsights";

export default SuccessionInsights;
